<div style="text-align: center; padding: 10% 10px 0 10px" *ngIf="app">
  <div>
    <img [src]="'/apps/' + app.id + '/splash.png'" width="180" align="center" />
  </div>

  <div class="frame">
    <div style="font-size: x-large; margin-bottom: 1rem">
      {{ _common.WelcomeTo }} {{ app.name }}!
    </div>
    <div style="margin-bottom: 10px; font-size: x-large">
      <fa-icon icon="check-circle" style="color: #409e4c"></fa-icon>
    </div>

    <div style="margin-bottom: 5px">{{ _common.EmailVerified }}</div>
    <div>{{ _common.CanLogin }} {{ app.name }} {{ _common.CanLogin_acc }}</div>

    <ng-container *ngIf="!isMobile">
      <a [href]="endpoint" class="link" *ngIf="endpoint && endpoint != ''">
        <div class="button" style="margin-bottom: 0">
          <span>Go To App</span>
        </div>
      </a>
    </ng-container>
    <ng-container *ngIf="isMobile">
      <a [href]="mobile" class="link" *ngIf="mobile && mobile != ''">
        <div class="button" style="margin-bottom: 0">
          <span>Go To App</span>
        </div>
      </a>
    </ng-container>
    <div *ngIf="app.apps" style="margin-top: 30px">
      <div style="display: flex; justify-content: center">
        <a [href]="app.apps.ios">
          <img src="/images/app_store_small.png" />
        </a>
        <div style="width: 50px"></div>
        <a [href]="app.apps.android">
          <img src="/images/play_store_small.png" />
        </a>
      </div>
    </div>
    <a [href]="'/?app=' + app.id" class="link" *ngIf="!endpoint || endpoint == ''">
      <div class="button" style="margin-bottom: 0">
        <span>{{ _common.GoToLogin }}</span>
      </div>
    </a>
  </div>
</div>